import React, { memo } from 'react';

import FormGroup from '../../helpers/FormGroup';
import BaseCheckbox from '../../helpers/Checkbox';
import PrettyError from '../../decorators/PrettyError';
import DisplayError from '../../decorators/DisplayError';

const Checkbox = PrettyError(DisplayError(BaseCheckbox));

const SharedDealNoteComponent = ({ buyer, onChangeCompanyIds }) => {
  let selectedCompaniesIdsList = [];

  if (buyer.get('subsidiaries').get(0) && buyer.get('subsidiaries').get(0).size > 0) {
    selectedCompaniesIdsList = [...buyer.get('subsidiaries')];
  }

  if (buyer.get('parent').size > 0) {
    selectedCompaniesIdsList.push(buyer.get('parent'));
  }

  if (selectedCompaniesIdsList.length === 0) return null;

  const companiesIdsList = selectedCompaniesIdsList.map(selectedCompaniesId => (
    <Checkbox
      key={selectedCompaniesId.get('id')}
      label={selectedCompaniesId.get('legalName')}
      name="selectedCompaniesIds"
      onChange={onChangeCompanyIds}
      value={selectedCompaniesId.get('id')}
    />
  ));

  return (
    <FormGroup className="group-checkbox">
      <label className="field-label">Share deal note with</label>
      {companiesIdsList}
    </FormGroup>
  );
};

export const SharedDealNote = memo(SharedDealNoteComponent);
